import App from './pages/App';
// prettier-ignore
import { notification } from "antd";
import { NotificationInstance } from 'antd/es/notification/interface';
import { Amplify } from "aws-amplify";
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import AnalyticsProvider from './components/AnalyticsProvider';
import Icon, { ICON_NAME } from './components/Icon';
import Theme from "./components/Theme";
import ConfigAnt from './components/Theme/ConfigAnt';
import { store } from './util/store/store';
import './util/styles/styles.scss';
import { awsConfig } from "./util/varibles/aws-config";
import { IPropsChildren } from './util/varibles/interface';

export let callNotify: NotificationInstance | undefined;

export const WrapperStore: React.FC<IPropsChildren> = ({ children }) => {
    return <Provider store={store}>
        {children}
    </Provider>
}

export const NotificationWrapper = () => {
    const [notify, contextHolder] = notification.useNotification({
        closeIcon: <Icon icon={ICON_NAME.CLOSE} bg="colorMain" />,
        styles: {
            root: {
                background: 'var(--bgPage)',
                borderRadius: '6px'
            },
        }
    });

    useEffect(() => {
        callNotify = notify
    }, [notify])

    return <WrapperStore>
        <ConfigAnt>
            <Theme notify={notify}>
                {contextHolder}
                <App />
            </Theme>
        </ConfigAnt>
    </WrapperStore>
};

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <AnalyticsProvider>
        <NotificationWrapper />
    </AnalyticsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
